var config = require('@sb/config')

function getWidgetAPIVersion () {
	if (window.subiz_account_id && window.subiz_account_id > 0) return '1'
	if (isV2()) return '2'
	if (isV4_1()) return '4.1'
	if (isV4_2()) return '4.2'
	return undefined
}

// isV4 tells whether the website is using widget version 4.1 or not
function isV4_1 () {
	var scripts = document.getElementsByTagName('script')
	if (!(window._sbzq instanceof Array)) return false

	for (let s of scripts) {
		if (!s || !s.src) continue
		if (s.src.indexOf(config.BaseURL) !== -1) return true
	}
	return false
}

// isV4 tells whether the website is using widget version 4.2 or not
function isV4_2 () {
	if (window.sbz_v4) return true
	var scripts = document.getElementsByTagName('script')
	if (typeof window.subiz !== 'function') return false

	for (let s of scripts) {
		if (!s || !s.src) continue
		if (s.src.indexOf(config.BaseURL) !== -1) return true
	}
	return false
}

// isV2 tells whether the website is using widget version 2 or not
function isV2 () {
	if (!window._sbzq) return false
	var scripts = document.getElementsByTagName('script')
	for (let s of scripts) {
		if (!s || !s.src) continue
		if (s.src.indexOf('static.subiz.com') !== -1) return true
	}
	return false
}

module.exports = getWidgetAPIVersion
